import React from 'react'
import { Row, Text } from '@/components/core'
import { classNameBuilder } from '@/helpers'

export const StarMarker: React.FC<{ active?: boolean; className?: string }> = ({
  active,
  className
}) => (
  <div
    className={classNameBuilder(
      'relative flex h-5 w-5 items-center justify-center rounded-full text-white',
      className,
      active ? 'bg-electric-indigo-500' : 'bg-gray-400'
    )}
  >
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1168_9120)">
        <path
          d="M3.99984 0.666656L5.02984 2.75332L7.33317 3.08999L5.6665 4.71332L6.05984 7.00666L3.99984 5.92332L1.93984 7.00666L2.33317 4.71332L0.666504 3.08999L2.96984 2.75332L3.99984 0.666656Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1168_9120">
          <rect width="8" height="8" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
    <Row
      className={classNameBuilder(
        'absolute top-[30px] h-[20px] w-[130px] items-center justify-center rounded px-0.5',
        active ? 'bg-electric-indigo-50' : 'bg-gray-50'
      )}
    >
      <Text.Translated
        translationKey="fluency_level_app_resultado_page"
        color="none"
        className={active ? 'text-electric-indigo-500' : 'text-gray-300'}
        size="8"
        fontWeight="bold"
        transform="uppercase"
        align="right"
      />
      <svg
        className={classNameBuilder(
          'absolute top-[-11px] h-3 w-3 rotate-180',
          active ? 'fill-electric-indigo-50' : 'fill-gray-50'
        )}
        x="0px"
        y="0px"
        viewBox="0 0 255 255"
      >
        <polygon points="127.5,127.5 0,0 255,0" />
      </svg>
    </Row>
  </div>
)

export default StarMarker
